/**
 * LaTeX 수식을 Unicode 텍스트로 변환하는 유틸리티
 */

// 그리스 문자 매핑
const GREEK_LETTERS = {
    '\\alpha': 'α', '\\beta': 'β', '\\gamma': 'γ', '\\delta': 'δ',
    '\\epsilon': 'ε', '\\varepsilon': 'ε', '\\zeta': 'ζ', '\\eta': 'η',
    '\\theta': 'θ', '\\vartheta': 'ϑ', '\\iota': 'ι', '\\kappa': 'κ',
    '\\lambda': 'λ', '\\mu': 'μ', '\\nu': 'ν', '\\xi': 'ξ',
    '\\pi': 'π', '\\varpi': 'ϖ', '\\rho': 'ρ', '\\varrho': 'ϱ',
    '\\sigma': 'σ', '\\varsigma': 'ς', '\\tau': 'τ', '\\upsilon': 'υ',
    '\\phi': 'φ', '\\varphi': 'φ', '\\chi': 'χ', '\\psi': 'ψ',
    '\\omega': 'ω',
    // 대문자 그리스 문자
    '\\Alpha': 'Α', '\\Beta': 'Β', '\\Gamma': 'Γ', '\\Delta': 'Δ',
    '\\Epsilon': 'Ε', '\\Zeta': 'Ζ', '\\Eta': 'Η', '\\Theta': 'Θ',
    '\\Iota': 'Ι', '\\Kappa': 'Κ', '\\Lambda': 'Λ', '\\Mu': 'Μ',
    '\\Nu': 'Ν', '\\Xi': 'Ξ', '\\Pi': 'Π', '\\Rho': 'Ρ',
    '\\Sigma': 'Σ', '\\Tau': 'Τ', '\\Upsilon': 'Υ', '\\Phi': 'Φ',
    '\\Chi': 'Χ', '\\Psi': 'Ψ', '\\Omega': 'Ω'
};

// 수학 기호 매핑
const MATH_SYMBOLS = {
    '\\times': '×', '\\div': '÷', '\\pm': '±', '\\mp': '∓',
    '\\cdot': '·', '\\circ': '∘', '\\star': '★', '\\bullet': '•',
    '\\neq': '≠', '\\ne': '≠', '\\leq': '≤', '\\le': '≤',
    '\\geq': '≥', '\\ge': '≥', '\\ll': '≪', '\\gg': '≫',
    '\\approx': '≈', '\\sim': '∼', '\\simeq': '≃', '\\equiv': '≡',
    '\\subset': '⊂', '\\supset': '⊃', '\\subseteq': '⊆', '\\supseteq': '⊇',
    '\\in': '∈', '\\notin': '∉', '\\ni': '∋',
    '\\cup': '∪', '\\cap': '∩', '\\setminus': '∖',
    '\\forall': '∀', '\\exists': '∃', '\\nexists': '∄',
    '\\infty': '∞', '\\nabla': '∇', '\\partial': '∂',
    '\\rightarrow': '→', '\\leftarrow': '←', '\\leftrightarrow': '↔',
    '\\Rightarrow': '⇒', '\\Leftarrow': '⇐', '\\Leftrightarrow': '⇔',
    '\\to': '→', '\\gets': '←', '\\mapsto': '↦',
    '\\ldots': '…', '\\cdots': '⋯', '\\vdots': '⋮', '\\ddots': '⋱',
    '\\prime': '′', '\\emptyset': '∅', '\\varnothing': '∅',
    '\\propto': '∝', '\\perp': '⊥', '\\parallel': '∥',
    '\\angle': '∠', '\\triangle': '△',
    '\\neg': '¬', '\\land': '∧', '\\lor': '∨',
    '\\oplus': '⊕', '\\otimes': '⊗',
    '\\mathcal{O}': 'O', '\\mathbb{R}': 'ℝ', '\\mathbb{N}': 'ℕ',
    '\\mathbb{Z}': 'ℤ', '\\mathbb{Q}': 'ℚ', '\\mathbb{C}': 'ℂ'
};

// 위첨자 매핑
const SUPERSCRIPTS = {
    '0': '⁰', '1': '¹', '2': '²', '3': '³', '4': '⁴',
    '5': '⁵', '6': '⁶', '7': '⁷', '8': '⁸', '9': '⁹',
    '+': '⁺', '-': '⁻', '=': '⁼', '(': '⁽', ')': '⁾',
    'n': 'ⁿ', 'i': 'ⁱ', 'x': 'ˣ', 'y': 'ʸ', 'a': 'ᵃ',
    'b': 'ᵇ', 'c': 'ᶜ', 'd': 'ᵈ', 'e': 'ᵉ', 'f': 'ᶠ',
    'g': 'ᵍ', 'h': 'ʰ', 'j': 'ʲ', 'k': 'ᵏ', 'l': 'ˡ',
    'm': 'ᵐ', 'o': 'ᵒ', 'p': 'ᵖ', 'r': 'ʳ', 's': 'ˢ',
    't': 'ᵗ', 'u': 'ᵘ', 'v': 'ᵛ', 'w': 'ʷ', 'z': 'ᶻ',
    'T': 'ᵀ', '*': '*'
};

// 아래첨자 매핑
const SUBSCRIPTS = {
    '0': '₀', '1': '₁', '2': '₂', '3': '₃', '4': '₄',
    '5': '₅', '6': '₆', '7': '₇', '8': '₈', '9': '₉',
    '+': '₊', '-': '₋', '=': '₌', '(': '₍', ')': '₎',
    'a': 'ₐ', 'e': 'ₑ', 'h': 'ₕ', 'i': 'ᵢ', 'j': 'ⱼ',
    'k': 'ₖ', 'l': 'ₗ', 'm': 'ₘ', 'n': 'ₙ', 'o': 'ₒ',
    'p': 'ₚ', 'r': 'ᵣ', 's': 'ₛ', 't': 'ₜ', 'u': 'ᵤ',
    'v': 'ᵥ', 'x': 'ₓ',
    // 그리스 문자
    'α': 'ₐ', 'β': 'ᵦ', 'γ': 'ᵧ', 'ρ': 'ᵨ', 'φ': 'ᵩ', 'χ': 'ᵪ'
};

// 텍스트 아래첨자 매핑 (min, max, opt 등)
const TEXT_SUBSCRIPTS = {
    'min': 'ₘᵢₙ',
    'max': 'ₘₐₓ',
    'opt': 'ₒₚₜ',
    'eff': 'ₑff',
    'avg': 'ₐᵥg',
    'tot': 'ₜₒₜ',
    'ref': 'ᵣₑf',
    'in': 'ᵢₙ',
    'out': 'ₒᵤₜ',
    'new': 'ₙₑw',
    'old': 'ₒₗd',
    'src': 'ₛᵣc',
    'dst': 'dₛₜ',
    'init': 'ᵢₙᵢₜ'
};

/**
 * 문자열을 위첨자로 변환
 */
const toSuperscript = (text) => {
    // 모든 문자가 변환 가능한지 확인
    const allConvertible = text.split('').every(char => SUPERSCRIPTS[char]);
    if (allConvertible) {
        return text.split('').map(char => SUPERSCRIPTS[char]).join('');
    }
    // 변환 불가능한 문자가 있으면 괄호 형태로 표시
    return `^(${text})`;
};

/**
 * 문자열을 아래첨자로 변환
 */
const toSubscript = (text) => {
    // 먼저 텍스트 아래첨자 확인
    if (TEXT_SUBSCRIPTS[text]) {
        return TEXT_SUBSCRIPTS[text];
    }
    // 모든 문자가 변환 가능한지 확인
    const allConvertible = text.split('').every(char => SUBSCRIPTS[char]);
    if (allConvertible) {
        return text.split('').map(char => SUBSCRIPTS[char]).join('');
    }
    // 변환 불가능한 문자가 있으면 괄호 형태로 표시
    return `_(${text})`;
};

/**
 * 복잡한 LaTeX 구조 변환
 */
const convertComplexLatex = (text) => {
    let result = text;

    // \frac{분자}{분모} → (분자/분모)
    result = result.replace(/\\frac\{([^{}]*)\}\{([^{}]*)\}/g, (match, num, den) => {
        return `(${num}/${den})`;
    });

    // \sqrt{x} → √(x)
    result = result.replace(/\\sqrt\{([^{}]*)\}/g, (match, content) => {
        return `√(${content})`;
    });

    // \sqrt[n]{x} → ⁿ√(x)
    result = result.replace(/\\sqrt\[([^\]]+)\]\{([^{}]*)\}/g, (match, n, content) => {
        return `${toSuperscript(n)}√(${content})`;
    });

    // \begin{cases}...\end{cases} → { 조건1; 조건2; ... }
    result = result.replace(/\\begin\{cases\}(.*?)\\end\{cases\}/gs, (match, content) => {
        const cases = content.split('\\\\').map(c => c.trim().replace(/&/g, ' '));
        return `{ ${cases.join('; ')} }`;
    });

    // \text{...} → 그냥 텍스트
    result = result.replace(/\\text\{([^{}]*)\}/g, '$1');
    result = result.replace(/\\textbf\{([^{}]*)\}/g, '$1');
    result = result.replace(/\\textit\{([^{}]*)\}/g, '$1');
    result = result.replace(/\\mathrm\{([^{}]*)\}/g, '$1');

    // 합, 곱, 적분 기호
    result = result.replace(/\\sum(?=[^a-zA-Z]|$)/g, 'Σ');
    result = result.replace(/\\prod(?=[^a-zA-Z]|$)/g, 'Π');
    result = result.replace(/\\int(?=[^a-zA-Z]|$)/g, '∫');
    result = result.replace(/\\oint(?=[^a-zA-Z]|$)/g, '∮');
    result = result.replace(/\\lim(?=[^a-zA-Z]|$)/g, 'lim');

    // \log, \exp, \sin, \cos 등
    result = result.replace(/\\log(?=[^a-zA-Z]|$)/g, 'log');
    result = result.replace(/\\ln(?=[^a-zA-Z]|$)/g, 'ln');
    result = result.replace(/\\exp(?=[^a-zA-Z]|$)/g, 'exp');
    result = result.replace(/\\sin(?=[^a-zA-Z]|$)/g, 'sin');
    result = result.replace(/\\cos(?=[^a-zA-Z]|$)/g, 'cos');
    result = result.replace(/\\tan(?=[^a-zA-Z]|$)/g, 'tan');
    result = result.replace(/\\max(?=[^a-zA-Z]|$)/g, 'max');
    result = result.replace(/\\min(?=[^a-zA-Z]|$)/g, 'min');
    result = result.replace(/\\arg(?=[^a-zA-Z]|$)/g, 'arg');

    return result;
};

/**
 * 그리스 문자 변환
 */
const convertGreekLetters = (text) => {
    let result = text;
    for (const [latex, unicode] of Object.entries(GREEK_LETTERS)) {
        // 단어 경계 처리
        const pattern = new RegExp(latex.replace('\\', '\\\\') + '(?=[^a-zA-Z]|$)', 'g');
        result = result.replace(pattern, unicode);
    }
    return result;
};

/**
 * 수학 기호 변환
 */
const convertMathSymbols = (text) => {
    let result = text;
    for (const [latex, unicode] of Object.entries(MATH_SYMBOLS)) {
        const escaped = latex.replace(/[\\{}]/g, '\\$&');
        result = result.replace(new RegExp(escaped, 'g'), unicode);
    }
    return result;
};

/**
 * 위첨자/아래첨자 변환
 */
const convertScripts = (text) => {
    let result = text;

    // ^{...} 패턴 (중괄호 포함)
    result = result.replace(/\^\{([^{}]+)\}/g, (match, content) => {
        return toSuperscript(content);
    });

    // ^x 패턴 (단일 문자)
    result = result.replace(/\^([0-9a-zA-Z+\-=()])/g, (match, char) => {
        return toSuperscript(char);
    });

    // _{...} 패턴 (중괄호 포함)
    result = result.replace(/_\{([^{}]+)\}/g, (match, content) => {
        return toSubscript(content);
    });

    // _x 패턴 (단일 문자, 그리스 문자 포함)
    result = result.replace(/_([0-9a-zA-Z\u0370-\u03FF])/g, (match, char) => {
        return toSubscript(char);
    });

    return result;
};

/**
 * 불필요한 LaTeX 문법 정리
 */
const cleanupLatex = (text) => {
    let result = text;

    // \left, \right 제거
    result = result.replace(/\\left([(\[{])/g, '$1');
    result = result.replace(/\\right([)\]}])/g, '$1');
    result = result.replace(/\\left\./g, '');
    result = result.replace(/\\right\./g, '');

    // \, \; \: \! (공백 제어) 제거
    result = result.replace(/\\[,;:!]/g, ' ');

    // \\ (줄바꿈) 처리
    result = result.replace(/\\\\/g, ' ');

    // & (정렬 문자) 제거
    result = result.replace(/&/g, ' ');

    // 남은 백슬래시 명령어 정리
    result = result.replace(/\\[a-zA-Z]+/g, '');

    // 연속 공백 정리
    result = result.replace(/\s+/g, ' ');

    return result.trim();
};

/**
 * LaTeX 수식을 Unicode 텍스트로 변환
 * @param {string} text - LaTeX 수식을 포함한 텍스트
 * @returns {string} Unicode로 변환된 텍스트
 */
export const convertLatexToUnicode = (text) => {
    if (!text) return text;

    let result = text;

    // $$ ... $$ (display math) 처리
    result = result.replace(/\$\$(.*?)\$\$/gs, (match, latex) => {
        let converted = latex.trim();
        converted = convertComplexLatex(converted);
        converted = convertGreekLetters(converted);
        converted = convertMathSymbols(converted);
        converted = convertScripts(converted);
        converted = cleanupLatex(converted);
        return converted;
    });

    // $ ... $ (inline math) 처리
    result = result.replace(/\$(.*?)\$/g, (match, latex) => {
        let converted = latex.trim();
        converted = convertComplexLatex(converted);
        converted = convertGreekLetters(converted);
        converted = convertMathSymbols(converted);
        converted = convertScripts(converted);
        converted = cleanupLatex(converted);
        return converted;
    });

    // $ 없이 직접 사용된 LaTeX 명령어 처리 (그리스 문자, 기호 등)
    result = convertComplexLatex(result);
    result = convertGreekLetters(result);
    result = convertMathSymbols(result);
    result = convertScripts(result);

    return result;
};

export default convertLatexToUnicode;
